import { render, staticRenderFns } from "./CategoryNew.vue?vue&type=template&id=0dd65989&"
import script from "./CategoryNew.vue?vue&type=script&lang=ts&"
export * from "./CategoryNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports